<template>
  <div>
    <Header name="Indicação de Rede" titleLabel="Indicação de Rede" backRoute="/indicacao-de-credenciados" />
    <omint-page-content v-if="pedido">
      <OmtTypography as="h1-bold" mb="15px" line-height="32px"> Resultado da indicação </OmtTypography>
      <OmtCard p="0px" mb="24px">
        <CFlex p="12px 16px 16px" align-items="top">
          <OmtIcons name="user-doctor" size="lg" color="var(--colors-light-primary-gray)" mr="16px" min-width="14px" />
          <Cbox>
            <OmtTypography as="h3-semi-bold" mb="16px"> {{ pedido.DescricaoPedido }}</OmtTypography>
            <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
              {{ `${pedido.DataPedido} - Protocolo: ${pedido.Protocolo}` }}</OmtTypography
            >
          </Cbox>
        </CFlex>
        <CFlex
          p="12px 16px 16px"
          align-items="top"
          background="var(--colors-light-primary-light-gray)"
          borderRadius="0px 0px 8px 8px"
          v-if="indicacao.Observacao"
        >
          <OmtIcons name="message-plus" size="lg" color="var(--colors-primary-gray)" mr="16px" min-width="14px" />
          <Cbox>
            <OmtTypography as="h3-semi-bold" mb="16px"> Resposta Omint</OmtTypography>
            <OmtTypography as="p1" line-height="22px">{{ indicacao.Observacao }}</OmtTypography>
          </Cbox>
        </CFlex>

        <!-- <AffiliateIndicationTile icon="fas fa-lightbulb" title="Nossa indicação" :description="descricaoIndicacao" />
        <CBox v-if="indicacao.Observacao">
          <omt-divider />
          <CBox pl="6">
            <omt-p>
              {{ indicacao.Observacao }}
            </omt-p>
          </CBox>
        </CBox> -->
      </OmtCard>
      <template v-if="credenciados.length">
        <CBox mb="4">
          <OmtTypography as="h2-bold" mb="16px" line-height="20px"> Credenciados indicados </OmtTypography>
        </CBox>
        <CBox
          v-for="credenciado in credenciados"
          :key="credenciado.CodigoPrestador"
          class="hover-effect"
          @click="handleClick(credenciado)"
        >
          <CFlex>
            <OmtIcons
              name="user-doctor"
              size="lg"
              color="var(--colors-primary-gray)"
              mr="16px"
              min-width="14px"
              height="32px"
              background="var(--colors-light-primary-light-gray)"
              p="8px 9px"
              borderRadius="4px"
            />

            <Cbox>
              <OmtTypography as="h2-bold" mb="8px" line-height="20px">
                {{ credenciado.DescricaoPrestador }}</OmtTypography
              >
              <OmtTypography mb="16px" as="p1" color="var(--colors-light-primary-gray2)">
                {{ credenciado.DescricaoEspecialidade }}
              </OmtTypography>
              <CFlex mb="16px">
                <OmtTypography as="p1" font-weight="400px" font-size="13px" mr="16px"> 1.1 km </OmtTypography>
                <OmtTypography as="p1-bold" mr="16px"> • </OmtTypography>
                <OmtIcons name="whatsapp" size="lg" color="#00C37D" mr="16px" min-width="14px" />
                <OmtTypography as="p1-bold" mr="16px"> • </OmtTypography>
                <OmtIcons name="video" size="lg" color="var(--colors-primary-gray)" mr="16px" min-width="14px" />
              </CFlex>
              <OmtTypography as="p1">
                {{ credenciado.TipoLogradouro }} {{ credenciado.EnderecoRua }}, {{ credenciado.EnderecoNumero }} <br />
                {{ credenciado.EnderecoBairro }} - {{ credenciado.CodigoEstado }}
              </OmtTypography>
            </Cbox>
            <CBox ml="auto">
              <OmtIcons name="angle-right" size="lg" color="var(--colors-primary-gray)" min-width="14px" />
            </CBox>
          </CFlex>
        </CBox>
      </template>
      <!-- <CBox v-if="credenciados.length" mb="4">
        <OmtTypography as="h1-bold" mb="15px" line-height="32px"> Credenciados indicados </OmtTypography>
        <omt-bold> </omt-bold>
      </CBox>

      <CBox v-if="credenciados.length" mb="4">
        <Cbox
          v-for="credenciado in credenciados"
          :key="credenciado.CodigoPrestador"
          class="hover-effect"
          @click="handleClick(credenciado)"
        >
          <AffiliateIndicationTile
            v-chakra
            p="4"
            :hasCountainer="true"
            icon="fas fa-user"
            :title="credenciado.DescricaoPrestador"
            :leadIcons="[credenciado.Favorito ? 'fas fa-heart' : 'far fa-heart']"
          />

          <CBox pl="48px">
            <CFlex align="baseline" v-if="credenciado.Distancia">
              <i class="fas fa-map-marker-alt fa-lg" v-chakra mr="3" />
              <omt-p>{{ Math.round(credenciado.Distancia * 100) / 100 }} km</omt-p>
            </CFlex>
            <omt-p>
              {{ credenciado.TipoLogradouro }} {{ credenciado.EnderecoRua }}, {{ credenciado.EnderecoNumero }} <br />
              {{ credenciado.EnderecoBairro }} - {{ credenciado.CodigoEstado }}
            </omt-p>
          </CBox>
          <omt-divider top="0" bottom="0" />
        </Cbox>
      </CBox> -->

      <!-- <RatingForm
        v-chakra
        pb="32px"
        v-if="recommendationDetail.NotaAvaliacao === null"
        tipo="10"
        etapa="P"
        :protocolo="pedido.Protocolo"
        @ratingSubmitClick="onNewRating"
      /> -->
    </omint-page-content>
    <Footer />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";
import BlockList from "@/components/Molecules/BlockList";
import RatingForm from "@/components/Organisms/RatingForm";
import AffiliateIndicationTile from "@/components/Organisms/AffiliateIndication/Tile";
import { CList, CListItem, CBox, CFlex } from "@chakra-ui/vue";

export default {
  name: "AffiliateIndicationVisualizeResults",
  components: { Footer, Header, AffiliateIndicationTile, CList, CListItem, CBox, CFlex, BlockList, RatingForm },
  computed: {
    ...mapState("affiliate", ["recommendationDetail"]),
    chamado() {
      return this.$route.params.chamado;
    },
    indicacao() {
      return this.recommendationDetail?.NossaIndicacao ?? {};
    },
    descricaoIndicacao() {
      return this.indicacao?.DataIndicacao ? `${this.indicacao.DataIndicacao} - ${this.indicacao.HoraIndicacao}` : "";
    },
    pedido() {
      return this.recommendationDetail?.SeuPedido ?? {};
    },
    credenciados() {
      return (
        this.recommendationDetail?.CredenciadosIndicados?.sort((a, b) => {
          if (a.Distancia < b.Distancia) return -1;
          if (a.Distancia > b.Distancia) return 1;
          return 0;
        }) ?? []
      );
    }
  },
  methods: {
    ...mapMutations("affiliate", ["SET_MATCH"]),
    ...mapActions("affiliate", ["fetchRecommendationDetail"]),
    async fetchResultDetail(force) {
      try {
        await this.$root.$emit("show-loading");
        await this.fetchRecommendationDetail({
          ticket: this.chamado,
          force
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    async handleClick(match) {
      await this.SET_MATCH(match);
      await this.$router.push({
        name: "indication.accredited"
      });
    },
    async onNewRating() {
      await this.fetchResultDetail(true);
    }
  },
  async mounted() {
    if (!this.chamado) {
      await this.$router.replace("/indicacao-de-credenciados");
      return;
    }
    await this.fetchResultDetail(false);
    if (!this.pedido.Protocolo) {
      await this.$router.replace("/indicacao-de-credenciados");
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
.block-list.block:first-of-type {
  margin-top: 0 !important;
}

.indications-list {
  max-height: calc(100vh - 400px);
  overflow-y: scroll;
}
.dots-vertical {
  position: absolute;
  height: calc(100% - 1rem);
  top: 0;
  left: 0;
  margin: 24px 5px;
  z-index: 0;
  border-left: 4px dotted var(--colors-gray-500);
  opacity: 0.25;
}

.big-font-size .dots-vertical {
  margin-left: 8px;
}

.hover-effect {
  transition: opacity 0.5s ease;

  &:hover {
    opacity: 0.6;
    cursor: pointer;
  }
}
</style>
